import Vue from 'vue';

export default {
    avoidListSet: {},
    tagKeySet: {},
    projectlist: [],
    projecttotal: 0,
    tagValueSet: {},
    avoidSet: {},
    createAvoidSet: {},
    describeKecIamRoles: {},
    keySet: {}
}